/* Nordic Blue — storefront enhancements */

/* Click-to-copy discount code (.nb-copy with data-code) */
document.addEventListener('click', async (event) => {
  const chip = event.target.closest('.nb-copy[data-code]');
  if (!chip) return;
  try {
    await navigator.clipboard.writeText(chip.dataset.code);
    const original = chip.textContent;
    chip.textContent = 'Copied ✓';
    chip.classList.add('nb-copy--copied');
    setTimeout(() => {
      chip.textContent = original;
      chip.classList.remove('nb-copy--copied');
    }, 1500);
  } catch (error) {
    console.error('[nordic-blue] copy failed', error);
  }
});

/* Dispatch countdown — .nb-dispatch with data-cutoff-hour, Europe/Stockholm weekdays */
document.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector('.nb-dispatch');
  if (!el) return;
  const cutoffHour = Number(el.dataset.cutoffHour || 14);
  const update = () => {
    const now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Stockholm' }));
    const day = now.getDay();
    const isWeekday = day >= 1 && day <= 5;
    const beforeCutoff = now.getHours() < cutoffHour;
    if (!isWeekday || !beforeCutoff) {
      el.classList.remove('nb-dispatch--visible');
      return;
    }
    const cutoff = new Date(now);
    cutoff.setHours(cutoffHour, 0, 0, 0);
    const diffMinutes = Math.floor((cutoff - now) / 60000);
    const h = Math.floor(diffMinutes / 60);
    const m = diffMinutes % 60;
    const parts = h > 0 ? `${h}h ${m}m` : `${m}m`;
    el.innerHTML = `📦 Order within <strong>${parts}</strong> and we dispatch <strong>today</strong>`;
    el.classList.add('nb-dispatch--visible');
  };
  update();
  setInterval(update, 30000);
});

/* Sticky add-to-cart bar (mobile product page) — shows when main buy button scrolls out */
document.addEventListener('DOMContentLoaded', () => {
  const bar = document.querySelector('.nb-sticky-atc');
  if (!bar) return;
  const target = document.querySelector('.product-form__submit');
  if (!target || !('IntersectionObserver' in window)) return;
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        bar.classList.toggle('nb-sticky-atc--visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    },
    { threshold: 0 }
  );
  observer.observe(target);
  bar.querySelector('.nb-sticky-atc__button')?.addEventListener('click', () => {
    target.click();
  });
});

/* Free shipping meter — converts shop-currency threshold to the active currency */
const nbUpdateShipmeters = () => {
  document.querySelectorAll('.nb-shipmeter').forEach((el) => {
    if (el.dataset.nbInit) return;
    el.dataset.nbInit = '1';
    const rate = Number((window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1);
    const active = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    const threshold = Number(el.dataset.thresholdCents) * rate;
    const total = Number(el.dataset.cartTotal);
    if (!threshold || Number.isNaN(total)) return;
    const label = el.querySelector('.nb-shipmeter__label');
    const fill = el.querySelector('.nb-shipmeter__fill');
    fill.style.width = `${Math.min(100, (total / threshold) * 100)}%`;
    if (total >= threshold) {
      label.textContent = "You've unlocked free shipping! 🎉";
      label.classList.add('nb-shipmeter__label--done');
      fill.classList.add('nb-shipmeter__fill--done');
    } else {
      const fmt = new Intl.NumberFormat(undefined, { style: 'currency', currency: active });
      const note = el.dataset.note ? ` (${el.dataset.note})` : '';
      label.innerHTML = `<strong>${fmt.format((threshold - total) / 100)}</strong> away from free shipping<span class="nb-shipmeter__note">${note}</span>`;
    }
  });
};
document.addEventListener('DOMContentLoaded', () => {
  nbUpdateShipmeters();
  const drawer = document.querySelector('cart-drawer');
  if (drawer) new MutationObserver(nbUpdateShipmeters).observe(drawer, { childList: true, subtree: true });
});

/* Social proof toasts — real recent purchases from nordic-purchases.json */
document.addEventListener('DOMContentLoaded', async () => {
  const host = document.querySelector('.nb-proof-host');
  if (!host || sessionStorage.getItem('nbProofDismissed')) return;
  const MAX_PER_SESSION = 4;
  let shown = Number(sessionStorage.getItem('nbProofShown') || 0);
  if (shown >= MAX_PER_SESSION) return;
  let purchases;
  try {
    purchases = await (await fetch(host.dataset.src)).json();
  } catch (error) {
    return;
  }
  if (!Array.isArray(purchases) || purchases.length === 0) return;
  const pool = purchases.slice().sort(() => Math.random() - 0.5);
  const flag = (cc) => cc.toUpperCase().replace(/./g, (c) => String.fromCodePoint(127397 + c.charCodeAt(0)));
  const ago = (iso) => {
    const days = Math.floor((Date.now() - new Date(iso).getTime()) / 86400000);
    if (days <= 0) return 'today';
    if (days === 1) return 'yesterday';
    if (days <= 14) return `${days} days ago`;
    return 'recently';
  };
  let index = 0;
  const showNext = () => {
    if (shown >= MAX_PER_SESSION || index >= pool.length || sessionStorage.getItem('nbProofDismissed')) return;
    const p = pool[index++];
    shown++;
    sessionStorage.setItem('nbProofShown', String(shown));
    host.innerHTML = `
      <a class="nb-proof" href="/products/${p.handle}">
        <img src="${p.img}" alt="" width="44" height="44" loading="lazy">
        <span class="nb-proof__body">
          <span class="nb-proof__text">Someone in <strong>${p.city} ${flag(p.cc)}</strong> bought</span>
          <span class="nb-proof__product"></span>
          <span class="nb-proof__ago">${ago(p.at)}</span>
        </span>
        <button type="button" class="nb-proof__close" aria-label="Dismiss">×</button>
      </a>`;
    const toast = host.firstElementChild;
    toast.querySelector('.nb-proof__product').textContent = p.title;
    if (document.querySelector('.nb-sticky-atc')) toast.classList.add('nb-proof--raised');
    requestAnimationFrame(() => requestAnimationFrame(() => toast.classList.add('nb-proof--in')));
    toast.querySelector('.nb-proof__close').addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      sessionStorage.setItem('nbProofDismissed', '1');
      host.innerHTML = '';
    });
    setTimeout(() => {
      toast.classList.remove('nb-proof--in');
      setTimeout(() => {
        if (host.firstElementChild === toast) host.innerHTML = '';
      }, 400);
    }, 6500);
    if (shown < MAX_PER_SESSION) setTimeout(showNext, 30000 + Math.random() * 25000);
  };
  setTimeout(showNext, 9000 + Math.random() * 6000);
});

/* Nordic Blue — global quick add-to-cart for .nb-add buttons */
document.addEventListener('click', async (event) => {
  const button = event.target.closest('.nb-add[data-variant-id]');
  if (!button || button.disabled) return;
  button.disabled = true;
  const originalText = button.textContent;
  try {
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const body = { items: [{ id: Number(button.dataset.variantId), quantity: 1 }] };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
    }
    const response = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(body),
    });
    const state = await response.json();
    if (!response.ok) throw new Error(state.description || 'Add to cart failed');
    button.textContent = 'ADDED ✓';
    button.classList.add('nb-add--added');
    if (cart && typeof cart.renderContents === 'function') {
      if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      cart.renderContents(state);
    }
    setTimeout(() => {
      button.textContent = originalText;
      button.classList.remove('nb-add--added');
      button.disabled = false;
    }, 1200);
  } catch (error) {
    console.error('[nordic-blue]', error);
    button.textContent = originalText;
    button.disabled = false;
  }
});
